import "../style/cardServices_style.css";

export default function CardServices(props) {
  return (
    <div className="card">
      <div className="subcard">
        <div className="containertitleCard">
          <div className="titleCard">
            <div className="icon">
              A
            </div>
            <h3>Experiência</h3>
          </div>
        </div>
        <div className="descCard">
          <h2>IA WEB</h2>
          <p>
            Olá eu sou o Evandro criador desta mesma página, Sou estudante, é a
            tecnologia.
          </p>
        </div>
      </div>
    </div>
  );
}
